import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../caq-request/caq-request.service';
import { DespesasCorrentesDto } from '../../dtos/despesas-correntes-dto';

@Injectable({
  providedIn: 'root',
})
export class DespesasCorrentesService {
  private apiUrl = `${environment.apiUrl}/despesa-corrente`;

  constructor(private caqRequestService: CaqRequestService) {}

  private mapResponse(response: any): DespesasCorrentesDto {
    if (!response || (Array.isArray(response) && response.length === 0)) {
      return response as any;
    }

    return {
      total: response.despesaTotalNecessaria || 0,
      caqAno: response.caqAno || 0,
      caqMes: response.caqMes || 0,
      caqAlunoAno: response.caqAlunoAno || 0,
      caqAlunoMes: response.caqAlunoMes || 0,
      pessoal: {
        valor: response.despesaPessoal || 0,
        percentual: response.percDespesaPessoal || 0
      },
      subPessoal: {
        docentes: {
          valor: response.despesaProfessores || 0,
          percentual: response.percDespesaProfessores || 0
        },
        naoDocentes: {
          valor: response.despesaFuncionarios || 0,
          percentual: response.percDespesaFuncionarios || 0
        },
        auxiliares: {
          valor: response.despesaAuxiliares || 0,
          percentual: response.percDespesaAuxiliares || 0
        },
        encargos: {
          valor: response.despesaEncargosSociais || 0,
          percentual: response.percDespesaEncargosSociais || 0
        }
      },
      areaAdministrativa: {
        valor: response.despesaAreaAdministrativa || 0,
        percentual: response.percDespesaAreaAdministrativa || 0
      },
      autonomiaFinanceira: {
        valor: response.despesaAutonomiaFinanceiraUnidadesEnsino || 0,
        percentual: response.percFinanceiraUnidadesEnsino || 0
      },
      manutencaoBensServicos: {
        valor: response.despesaManutencaoBensServicos || 0,
        percentual: response.percDespesaManutencaoBensServicos || 0
      },
      formacaoValorizacao: {
        valor: response.despesaFormacaoValorizacaoProfissionaisEducacao || 0,
        percentual: response.percDespesaFormacaoValorizacaoProfissionaisEducacao || 0
      },
      servicosDiversos: {
        valor: response.despesaServicosDiversos || 0,
        percentual: response.percDespesaServicosDiversos || 0
      },
      alimentacaoEscolar: {
        valor: response.despesaAlimentacaoEscolar || 0,
        percentual: response.percDespesaAlimentacaoEscolar || 0
      }
    };
  }

  /**
   * Busca as despesas correntes projetadas CAQ para um município
   * @param idMunicipio Código IBGE do município
   * @param ano Ano de referência
   */
  porMunicipio(
    idMunicipio: number,
    ano: number,
  ): Observable<DespesasCorrentesDto> {
    return this.caqRequestService
      .get<any>(
        `${this.apiUrl}/municipio/rede/${idMunicipio}`,
      )
      .pipe(map((response) => this.mapResponse(response)));
  }

  /**
   * Busca as despesas correntes projetadas CAQ para o plano estadual
   * @param idEstado Código IBGE do estado
   * @param ano Ano de referência
   */
  porPlanoEstadual(
    idEstado: number,
    ano: number,
  ): Observable<DespesasCorrentesDto> {
    return this.caqRequestService
      .get<any>(
        `${this.apiUrl}/estado/plano/${idEstado}`,
      )
      .pipe(map((response) => this.mapResponse(response)));
  }

  /**
   * Busca as despesas correntes projetadas CAQ para a rede estadual
   * @param idEstado Código IBGE do estado
   * @param ano Ano de referência
   */
  porRedeEstadual(
    idEstado: number,
    ano: number,
  ): Observable<DespesasCorrentesDto> {
    return this.caqRequestService
      .get<any>(
        `${this.apiUrl}/estado/rede/${idEstado}`,
      )
      .pipe(map((response) => this.mapResponse(response)));
  }

  /**
   * Busca as despesas correntes projetadas CAQ por ano (Brasil)
   * @param ano Ano de referência
   */
  porAno(ano: number): Observable<DespesasCorrentesDto> {
    return this.caqRequestService
      .get<any>(`${this.apiUrl}/${ano}`)
      .pipe(map((response) => this.mapResponse(response)));
  }
}
